import React from "react";
import {GPS_URL} from '../../../constants'
import { useNavigate } from "react-router-dom";

const EligibilityCheckFormError = () => {

  const navigateToGpService = () => {
    window.location.href = `${GPS_URL}/docnow/`
  }
  const navigate = useNavigate();
  const handleOnBack = () => navigate(-1);
  return (
    <div className="container d-flex flex-column justify-content-between h-100">
      <div className="row">
        <div className="col-md-12 col-lg-12 col-xl-10 px-0 py-0">
          <div className="d-flex flex-column justify-content-between">
            <h4 className="d-none d-md-block mb-2 fw-bold">
              We regret to inform you that we are unable to prescribe medical
              cannabis if you are experiencing schizophrenia / Schizoaffective
              disorder or psychosis.
            </h4>
            <h5 className="d-block d-md-none mb-2 fw-bold">
              We regret to inform you that we are unable to prescribe medical
              cannabis if you are experiencing schizophrenia / Schizoaffective
              disorder or psychosis.
            </h5>
            <p className="text-gray-1 mb-4">
              We appreciate your understanding. If you require any additional
              information or believe that you are still eligible, please don't
              hesitate to reach out to us. Our team is always here to assist
              you.
            </p>
            <p className="my-3">
              Why not take a moment to discover more of the services and
              benefits we provide at Treat It clinic?
            </p>
          </div>
          <div className="row">
            <div className="col-md-7 col-lg-6">
              <div 
              className="gps-error-div px-4 py-3 rounded cursor-pointer w-100" 
              onClick={navigateToGpService}
              >
                <img
                  src="/images/eligibility/gps-logo.png"
                  alt="GPS logo"
                  className="gps-logo-img"
                />
                <p className="mb-0 mt-2 mb-1 fw-bold">Online GP Service</p>
                <p className="mb-0 mt-1 infocard-text">
                  Access medical care and advice from home through our virtual
                  doctor platform.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="column d-flex flex-row justify-content-center justify-content-md-end align-items-center">
        <div className="d-flex flex-column-reverse flex-md-row footer-div px-5 px-md-0 py-4 py-md-0">
          <button
            className="text-primary-600 bg-transparent w-100 w-md-fit h-fit fw-bold border-0 rounded text-nowrap"
            onClick={handleOnBack}
          >
            <p className="mb-0 fw-bold fs-6">Back</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EligibilityCheckFormError;
